<app-quick-action-dialog
  [isOpen]="isDialogOpen"
  [title]="'Delete account'"
  [isCloseable]="true"
  (backdropClick)="onBackdropClick()"
  (close)="onClose()"
>
  <!-- Content slot for confirmation message -->
  <div slot="content" class="delete-confirmation">
    @if (!isLastWalletAccount()) {
      <p>
        Are you sure you want to delete the account
        <strong>{{ accountName }}</strong
        >? This action cannot be undone and you will lose access to this account
        permanently.
      </p>
    }
    @if (isLastWalletAccount()) {
      <p>
        You can't delete the last wallet. You can remove only all wallets info
        from the settings menu.
      </p>
    }
  </div>

  <!-- Footer slot for action buttons -->
  <div slot="footer" class="button-row">
    <kc-button
      [text]="'Cancel'"
      [variant]="'secondary'"
      [size]="'m'"
      [isFullWidth]="true"
      (buttonClick)="onCancel()"
    />
    <kc-button
      class="kc-button-danger"
      [text]="'Delete'"
      [variant]="'secondary'"
      [size]="'m'"
      [isFullWidth]="true"
      [isDisabled]="isLastWalletAccount()"
      (buttonClick)="onDelete()"
    />
  </div>
</app-quick-action-dialog>
